import dayjs from "dayjs"
import { getDatetimeSegment } from "@/utils/flight/getDatetimeSegment"
import { FlatFareConfigMap, FlatFareRouteConfig } from "./flatFareProduct.types"
import { getFlatFareRouteKey } from "./parseFlatFareProducts"

type MatchFlatFarePromotionParams = {
  airline: string
  route: string
  actualPrice: number
  segmentCount: number
  departureTime?: string
  departureTzOffset?: string | number
  configMap: FlatFareConfigMap
}

export const matchFlatFarePromotion = ({
  airline,
  route,
  actualPrice,
  segmentCount,
  departureTime,
  departureTzOffset,
  configMap,
}: MatchFlatFarePromotionParams): { matched: boolean; config?: FlatFareRouteConfig } => {
  if (process.env.NEXT_PUBLIC_WEB !== "B2C") {
    return { matched: false }
  }

  const config = configMap[getFlatFareRouteKey(airline, route)]
  if (!config) {
    return { matched: false }
  }

  const expectedClientId = process.env.NEXT_PUBLIC_AUTHEN_API_CLIENT_ID || "TE"
  if (config.clientId && config.clientId !== expectedClientId) {
    return { matched: false }
  }

  if (segmentCount > config.maxLegs) {
    return { matched: false }
  }

  if (
    config.excludeFlightWithinHours
    && departureTime
  ) {
    const departure = getDatetimeSegment(departureTime, departureTzOffset != null ? String(departureTzOffset) : undefined)
    const hoursUntilDeparture = departure.diff(dayjs(), "hour", true)
    if (hoursUntilDeparture < config.excludeFlightWithinHours) {
      return { matched: false }
    }
  }

  if (actualPrice - config.fareAmount < config.minPriceDiff) {
    return { matched: false }
  }

  return { matched: true, config }
}
